import { SectionHeader, NavButtons, EmergencyBanner, Badge, levelClass } from "@/components/workflow/ui";
import { ClipboardList } from "lucide-react";

export default function StepTentative({ tentative, onBack, onNext }) {
  return (
    <div data-testid="tentative-section">
      <SectionHeader icon={ClipboardList} sub="Step 3 · System (internal)" title="Tentative differential" />
      {tentative.emergency_flag && <EmergencyBanner reason={tentative.emergency_reason} />}
      {tentative.summary && <p className="text-sm text-zinc-600 -mt-2 mb-6">{tentative.summary}</p>}
      <div className="space-y-px bg-zinc-200 border border-zinc-200 rounded-md overflow-hidden">
        {tentative.tentative_diagnoses?.map((d, i) => (
          <div key={d.condition || i} className="bg-white p-5">
            <div className="flex items-center justify-between gap-3">
              <h3 className="font-serif text-lg text-zinc-900">{d.condition}</h3>
              <Badge className={levelClass(d.likelihood)}>{d.likelihood}</Badge>
            </div>
            <p className="mt-2 text-sm text-zinc-600">{d.rationale}</p>
            {d.red_flags && <p className="mt-2 text-sm text-red-600"><span className="font-semibold">Red flags:</span> {d.red_flags}</p>}
          </div>
        ))}
      </div>
      {tentative.advice && <p className="mt-5 text-sm text-zinc-500 italic">{tentative.advice}</p>}
      <NavButtons onBack={onBack} onNext={onNext} nextLabel="Proceed to examination" nextTestId="to-examination-btn" />
    </div>
  );
}
